import Splide  from '@splidejs/splide';
import {createApp} from 'vue'

// import VUE components
import Example from './components/example.vue';

(function ($) {
    
    var $=require('jquery');
    window.jQuery = window.$ = $;
    require("./scss/main.scss");
    require('datatables.net');
    require('datatables.net-dt');
    require('leaflet');
    require('corejs-typeahead');
    require('typeahead-address-photon');
    window.Splide=Splide;

    let render_component = function (component, id, data) {
        createApp(component,data).mount(id);
    }

    ///// VUE DEFAULT SHORTCODES START

    ///// ##0 EXAMPLE
    window.render_example = function (id, dataValue) {
        return render_component(Example, id, dataValue);
    }
    ///// VUE DEFAULT SHORTCODES END

    window.init_splide = function(id,perPage,pagination,gap){
        var splide = new Splide(id, {
            type: 'loop',
            autoplay: true,
            perPage: perPage,
            pagination:pagination??true,
            gap: gap??0
            });
        splide.mount();
    }


})(window.jQuery); 